export default __webpack_public_path__ + "static/media/103.ea755410.jpg";